export enum HMSMessageRecipientType {
  BROADCAST = 'BROADCAST',
  PEER = 'PEER',
  ROLES = 'ROLES',
}
